var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowNextStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.278,
    height: 43.761,
    viewBox: "0 0 70.278 43.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M8839.86,4922.83,8875,4947.191l35.14-24.361v-19.4L8875,4927.791l-35.139-24.361Z",
    transform: "translate(-8839.86 -4903.43)",
    fill: "#693f23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowNextStep);
export default __webpack_public_path__ + "static/media/iconArrowNextStep.3679a9041beb95bc3c5fe8889f5e8224.svg";
export { ForwardRef as ReactComponent };